import { ApplicationConfiguration } from "./types";

/**
 * The global application configuration object. Used throughout our applications.
 * @note This is set by the `adapt-host` at startup, but begins pre-initialized for unit testing purposes.
 */
export let applicationConfig: ApplicationConfiguration = {
    environment: "production",
    // See https://mui.com/x/introduction/licensing/#license-key-security
    // deepcode ignore HardcodedNonCryptoSecret: It's safe to store the MUI X license key in the code, it's designed to be public.
    muiXLicenseKey:
        "bf83448c5518ab118108b7b1635714b9Tz0xMTI0MTksRT0xNzc3ODUyNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=",
};

export const __setApplicationConfiguration = (appConfig: ApplicationConfiguration) =>
    (applicationConfig = { ...applicationConfig, ...appConfig });
